export default {"src":"/_next/static/media/gray-bath.179c20f3.svg","height":2324,"width":2324,"blurWidth":0,"blurHeight":0};